module.exports = __webpack_public_path__ + "static/media/undraw_conference_speaker_re_1rna.eccf2813.svg";